class BeniPostHeroReserve extends HTMLElement {
  connectedCallback() {
    this.unsubscribedText = this.querySelector('[data-beni-post-hero-unsubscribed]');
    this.subscribedText = this.querySelector('[data-beni-post-hero-subscribed]');
    this.subscribeButton = this.querySelector('[data-beni-post-hero-open-subscribe]');
    this.handleSubscribeClick = (event) => this.openSubscribePopup(event);
    this.handleStorage = () => this.syncSubscribeState();
    this.handlePageShow = () => this.syncSubscribeState();
    this.handleFocus = () => this.syncSubscribeState();

    if (this.subscribeButton) {
      this.subscribeButton.addEventListener('click', this.handleSubscribeClick);
    }

    window.addEventListener('storage', this.handleStorage);
    window.addEventListener('pageshow', this.handlePageShow);
    window.addEventListener('focus', this.handleFocus);
    this.syncSubscribeState();

    if (window.MondoHomeLazyMedia && typeof window.MondoHomeLazyMedia.refresh === 'function') {
      window.MondoHomeLazyMedia.refresh(this);
    }
  }

  disconnectedCallback() {
    if (this.subscribeButton && this.handleSubscribeClick) {
      this.subscribeButton.removeEventListener('click', this.handleSubscribeClick);
    }

    if (this.handleStorage) {
      window.removeEventListener('storage', this.handleStorage);
    }

    if (this.handlePageShow) {
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    if (this.handleFocus) {
      window.removeEventListener('focus', this.handleFocus);
    }
  }

  syncSubscribeState() {
    const hasRecord = this.hasSubscriptionRecord();

    if (this.unsubscribedText) {
      this.unsubscribedText.hidden = hasRecord;
    }

    if (this.subscribedText) {
      this.subscribedText.hidden = !hasRecord;
    }
  }

  hasSubscriptionRecord() {
    try {
      return Boolean(window.MondoEmailAccess && window.MondoEmailAccess.hasRecord());
    } catch (error) {
      return false;
    }
  }

  openSubscribePopup(event) {
    event.preventDefault();

    if (this.hasSubscriptionRecord()) {
      this.syncSubscribeState();
      return;
    }

    if (typeof window.MondoOpenSubscribePopup === 'function') {
      if (window.MondoOpenSubscribePopup()) {
        return;
      }
    }

    if (this.openFallbackSubscribePopup()) {
      return;
    }

    window.setTimeout(() => {
      this.openFallbackSubscribePopup();
    }, 300);
  }

  openFallbackSubscribePopup() {
    const popupHost = document.querySelector('may-accessorize');
    if (popupHost && typeof popupHost.openPopup === 'function') {
      popupHost.openPopup();
      return true;
    }

    const tabbar = document.querySelector('[data-may-accessorize-tabbar]');
    if (tabbar) {
      tabbar.click();
      return true;
    }

    return false;
  }
}

if (!customElements.get('beni-post-hero-reserve')) {
  customElements.define('beni-post-hero-reserve', BeniPostHeroReserve);
}
